if (document.getElementById('wikisearch') != null || undefined) {
  document.getElementById('wikisearch').addEventListener('keyup', el => {
    let value = el.target.value.toLowerCase().trim(),
      emptyBool = true;
    if (value !== '') {
      document.querySelectorAll('.group').forEach(el => {
        el.style.display = 'none';
      });
      document.querySelectorAll('.group ul li a').forEach(entry => {
        entry.style.display = 'none';
        const data = entry.dataset.text,
          dataTrim = data.toLowerCase().trim(),
          dataMark = data.replace(new RegExp(value, 'gi'), match => `<mark>${match}</mark>`);
        if (dataTrim.includes(value)) {
          entry.style.display = '';
          entry.closest('.group').style.display = '';
          entry.innerHTML = dataMark;
          emptyBool = false;
        }
      });
      document.querySelectorAll('#pkv-wiki .empty')[0].classList.toggle('active', emptyBool);
    } else {
      document.querySelectorAll('.group ul li a').forEach(entry => {
        entry.innerHTML = entry.dataset.text;
        entry.closest('.group').style.display = '';
        entry.style.display = '';
      });
    }
  });
}
if (document.getElementById('wikinav') != null || undefined) {
  document.getElementById('wikinav').addEventListener('scroll', e => {
    let el = document.getElementById('wikinav'),
      left = el.scrollLeft;
    el.parentElement.classList.toggle('left-hide', left < 24);
    el.parentElement.classList.toggle('right-hide', left > 26 * 21 - el.offsetWidth - 24);
  });
}
